// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, maybe, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

const isCustomObjectTypeSchemaDef = objectOf({
  type: string,
  properties: objectOf({}),
  required: maybe(arrayOf(string)),
});

// type_name and schema_def are required. The type-label fields are additive: keep them tolerant
// (maybe) so a response from an older backend during a rolling deploy still validates instead of
// failing the whole schema query; consumers already fall back to English defaults when absent.
export const isGetCustomObjectsCustomObjectTypeSchemaResult = objectOf({
  type_name: string,
  schema_def: isCustomObjectTypeSchemaDef,
  display_name_singular: maybe(string),
  display_name_plural: maybe(string),
  icon: maybe(string),
  description: maybe(string, true),
});
